var _defs, _g, _g2, _path, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVentilation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160mm",
    height: "160mm",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "Triangle",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3",
    x1: 150.01,
    x2: 236.01,
    y1: 107.94,
    y2: 107.94,
    gradientTransform: "translate(-94.906 -15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0af",
    offset: 0.22609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f00",
    offset: 0.57391
  })))), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#80ff00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.4159 135h148.58",
    strokeLinecap: "round",
    strokeWidth: 2.4548
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.094 105v-58.764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.09 134.02v-58.042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.09 59.918v-14.285"
  })))), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.601 55 25-25",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.6 55-25-25",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.094 135v-13.333",
    fill: "#80ff00"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m55.601 105s5.6498 5.6275 23.298 5c6.8886-0.24492 16.559-5 16.702-15 0.0908-6.3393-0.82819-14.903 5-23.029 5-6.9713 13.154-6.9713 18.554-4.8686 6.85 2.6672 10.939 4.3429 10.939 4.3429l1.1293-2.3757 1.4081-2.8868 7.969 13.817h-15l2.503-5c-11.951-6.0249-20.163-7.1724-25.273 2.4161-2.602 4.8825-2.2303 12.584-2.2303 17.584 0 5.2582-3.319 18.637-22.097 21.866-8.3789 1.4409-22.903 3.1337-22.903 3.1337l5-7.4793z",
    fill: "url(#linearGradient3)",
    style: {
      mixBlendMode: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.094 125s9.4022 0.37391 15-6.8399c12.344-15.907 12.734-50.645 15-83.16l-30-1e-6z",
    fill: "#00a8ff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#00dbff",
    strokeLinecap: "square",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.105 115 14.79 4e-3",
    markerEnd: "url(#Triangle)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.77 105 19.739 4e-3",
    markerEnd: "url(#Triangle)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.251 94.996 21.833 4e-3",
    markerEnd: "url(#Triangle)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.998 85 23.932 4e-3",
    markerEnd: "url(#Triangle)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.928 75 25.166 4e-3",
    markerEnd: "url(#Triangle)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.901 65 26.012 4e-3",
    markerEnd: "url(#Triangle)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.872 55 26.781 4e-3",
    markerEnd: "url(#Triangle)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.844 45 27.398 4e-3",
    markerEnd: "url(#Triangle)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentilation);
export default __webpack_public_path__ + "static/media/ventilation.c8cd0275e57b589df7eef6d1565a80f8.svg";
export { ForwardRef as ReactComponent };